
export interface BypassTranslationRow {
  keyword: string;
  en: string;
  sw: string;
}

export const BYPASS_TRANSLATIONS_SEED: BypassTranslationRow[] = [
  {
    "keyword": "projectskey",
    "en": "Projects",
    "sw": "Kimkakati"
  },
  {
    "keyword": "flagship",
    "en": "Flagship",
    "sw": "Miradi ya"
  },
  {
    "keyword": "features",
    "en": "Features",
    "sw": "Mfumo"
  },
  {
    "keyword": "system",
    "en": "System",
    "sw": "Vipengele vya"
  },
  {
    "keyword": "privacy-policy",
    "en": "Privacy Policy",
    "sw": "Sera ya Faragha"
  },
  {
    "keyword": "terms-&-conditions",
    "en": "Terms & Conditions",
    "sw": "Vigezo na Masharti"
  },
  {
    "keyword": "all-rights-reserved",
    "en": "All Rights Reserved",
    "sw": "Haki Zote Zimehifadhiwa"
  },
  {
    "keyword": "learn-more",
    "en": "Learn More",
    "sw": "Pata Maelezo Zaidi"
  },
  {
    "keyword": "priorities",
    "en": "Priorities",
    "sw": "Vyetu"
  },
  {
    "keyword": "our",
    "en": "Our",
    "sw": "Vipaumbele"
  },
  {
    "keyword": "view-document",
    "en": "View Document",
    "sw": "Angalia Nyaraka"
  },
  {
    "keyword": "assessment-of-environmental-projects-focusing-on-sustainability-climate-impact-and-community-engagement.",
    "en": "Assessment of environmental projects, focusing on sustainability, climate impact, and community engagement.",
    "sw": "Tathmini ya miradi ya mazingira, ikilenga uendelevu, athari za tabianchi, na ushirikishaji wa jamii."
  },
  {
    "keyword": "highlights-recent-changes-in-the-education-sector-policy-framework-and-implementation-guidelines.",
    "en": "Highlights recent changes in the education sector policy framework and implementation guidelines.",
    "sw": "Inaonyesha mabadiliko ya hivi karibuni katika mfumo wa sera za sekta ya elimu na miongozo ya utekelezaji."
  },
  {
    "keyword": "access-up-to-date-metrics-and-system-changes-instantly-as-data-is-submitted.",
    "en": "Access up-to-date metrics and system changes instantly as data is submitted.",
    "sw": "Pata takwimu za sasa na mabadiliko ya mfumo papo hapo taarifa inapotumwa kwa ufanisi na uharaka zaidi."
  },
  {
    "keyword": "transform-raw-data-into-interactive-dashboards-and-insights-for-informed-decision-making.",
    "en": "Transform raw data into interactive dashboards and insights for informed decision-making.",
    "sw": "Badilisha data ghafi kuwa dashibodi shirikishi na uchambuzi wa kina kwa ajili ya kufanya maamuzi sahihi."
  },
  {
    "keyword": "evaluation-of-healthcare-programs-and-outcomes-across-regions-with-recommendations-for-improvement.",
    "en": "Evaluation of healthcare programs and outcomes across regions with recommendations for improvement.",
    "sw": "Tathmini ya programu za afya na matokeo yake katika mikoa mbalimbali pamoja na mapendekezo ya kuboresha."
  },
  {
    "keyword": "capture,-validate,-and-manage-data-from-multiple-sources-in-a-structured-and-secure-way.",
    "en": "Capture, validate, and manage data from multiple sources in a structured and secure way.",
    "sw": "Kusanya, thibitisha, na simamia data kutoka vyanzo mbalimbali kwa njia iliyoandaliwa na salama."
  },
  {
    "keyword": "monitor-key-performance-indicators-against-defined-targets-to-measure-progress-and-impact.",
    "en": "Monitor key performance indicators against defined targets to measure progress and impact.",
    "sw": "Fuatilia viashiria muhimu vya utendaji kulingana na malengo yaliyowekwa ili kupima maendeleo na athari."
  },
  {
    "keyword": "a-comprehensive-overview-of-the-country’s-strategic-goals-and-targets-for-national-development-over-the-next-decade.",
    "en": "A comprehensive overview of the country’s strategic goals and targets for national development over the next decade.",
    "sw": "Muhtasari wa kina wa malengo na vipaumbele vya kimkakati vya taifa kwa maendeleo ya kitaifa katika muongo ujao."
  },
  {
    "keyword": "environmental-sustainability-study",
    "en": "Environmental Sustainability Study",
    "sw": "Uchunguzi wa Uendelevu wa Mazingira"
  },
  {
    "keyword": "education-policy-update",
    "en": "Education Policy Update",
    "sw": "Sasisho la Sera ya Elimu"
  },
  {
    "keyword": "health-sector-report-2025",
    "en": "Health Sector Report 2025",
    "sw": "Ripoti ya Sekta ya Afya 2025"
  },
  {
    "keyword": "national-development-plan-2050",
    "en": "National Development Plan 2050",
    "sw": "Mpango wa Maendeleo ya Taifa 2050"
  },
  {
    "keyword": "more-documents",
    "en": "More Documents",
    "sw": "Nyaraka Zaidi"
  },
  {
    "keyword": "articles",
    "en": "Articles",
    "sw": "Makala"
  },
  {
    "keyword": "documents-&",
    "en": "Documents &",
    "sw": "Nyaraka na"
  },
  {
    "keyword": "learning",
    "en": "Learning",
    "sw": "Kujifunza"
  },
  {
    "keyword": "evaluation",
    "en": "Evaluation",
    "sw": "Tathmini"
  },
  {
    "keyword": "view-projects",
    "en": "View Projects",
    "sw": "Tazama Miradi"
  },
  {
    "keyword": "monitoring",
    "en": "Monitoring",
    "sw": "Ufuatiliaji"
  },
  {
    "keyword": "real-time-updates",
    "en": "Real Time Updates",
    "sw": "Taarifa Papo Hapo"
  },
  {
    "keyword": "visual-analytics",
    "en": "Visual Analytics",
    "sw": "Uchambuzi wa Picha"
  },
  {
    "keyword": "data-collection",
    "en": "Data Collection",
    "sw": "Ukusanyaji Takwimu"
  },
  {
    "keyword": "track-indicators",
    "en": "Track Indicators",
    "sw": "Fuatilia Viashiria"
  },
  {
    "keyword": "designed-to-support-planning,-accountability,-and-national-development-outcomes.",
    "en": "Designed to support planning, accountability, and national development outcomes.",
    "sw": "Umebuniwa kusaidia upangaji, uwajibikaji, na matokeo ya maendeleo ya taifa."
  },
  {
    "keyword": "from-planning-to-performance,-all-in-one-m&e-system",
    "en": "From Planning to Performance, All in One M&E System",
    "sw": "Kuanzia Mpango hadi Matokeo, Mfumo Mmoja wa Ufuatiliaji na Tathmini"
  },
  {
    "keyword": "enrolled-institutions",
    "en": "Enrolled Institutions",
    "sw": "Taasisi Zilizosajiliwa"
  },
  {
    "keyword": "reporting-compliance",
    "en": "Reporting Compliance",
    "sw": "Uzingatiaji wa Ripoti"
  },
  {
    "keyword": "active-projects",
    "en": "Active Projects",
    "sw": "Miradi Hai"
  },
  {
    "keyword": "institutions-connected",
    "en": "Institutions Connected",
    "sw": "Taasisi Zilizohusishwa"
  },
  {
    "keyword": "if-your-question-goes-beyond-what's-covered-in-our-faqs,-please-send-us-an-email-and-our-team-will-be-glad-to-assist-you.",
    "en": "If your question goes beyond what’s covered in our FAQs, please send us an email and our team will be glad to assist you.",
    "sw": "Ikiwa swali lako halijajibiwa katika Maswali Yanayoulizwa Mara kwa Mara (FAQs), tafadhali tutumie barua pepe, na timu yetu itafurahi kukusaidia."
  },
  {
    "keyword": "often",
    "en": "Questions",
    "sw": "Mara kwa mara"
  },
  {
    "keyword": "faqkey",
    "en": "Frequently Asked",
    "sw": "Maswali ya"
  },
  {
    "keyword": "still-have-questions?",
    "en": "Still Have Questions?",
    "sw": "Bado una Maswali?"
  },
  {
    "keyword": "hero-description",
    "en": "A centralized Monitoring and Evaluation system that enables institutions to plan, track, analyze, and report performance against national, regional, and international development frameworks in real time.",
    "sw": "Mfumo wa kati wa Ufuatiliaji na Tathmini unaowezesha taasisi kupanga, kufuatilia utekelezaji, kufanya uchambuzi, na kuripoti utendaji kwa wakati halisi dhidi ya mifumo ya maendeleo ya kitaifa, kikanda na kimataifa."
  },
  {
    "keyword": "government-mel-system",
    "en": "Government MEL System",
    "sw": "Mfumo wa Kitaifa wa Ufuatiliaji na Tathmini"
  },
  {
    "keyword": "help-&-support",
    "en": "Help & Support",
    "sw": "Msaada & Huduma"
  },
  {
    "keyword": "dira-ya-maendeleo-2050",
    "en": "Tanzania Development Vision 2050",
    "sw": "Dira ya Maendeleo 2050"
  },
  {
    "keyword": "login",
    "en": "Login",
    "sw": "Ingia"
  },
  {
    "keyword": "featured-documents",
    "en": "Featured Documents",
    "sw": "Nyaraka Muhimu"
  },
  {
    "keyword": "about-us",
    "en": "About us",
    "sw": "Kuhusu sisi"
  },
  {
    "keyword": "settings",
    "en": "Settings",
    "sw": "Mpangilio"
  },
  {
    "keyword": "home",
    "en": "Home",
    "sw": "Nyumbani"
  }
];
